import { env } from "../lib/env";
import { supabase } from "../supabaseClient";
import type { ApiErrorResponse } from "./types";

type RequestOptions = RequestInit & {
  headers?: HeadersInit;
};

async function parseJsonSafely(response: Response) {
  const text = await response.text();

  if (!text) {
    return null;
  }

  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
}

export async function apiFetch<T>(
  path: string,
  options: RequestOptions = {},
): Promise<T> {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  const baseUrl = env.apiBaseUrl.replace(/\/+$/, "");
  const url = `${baseUrl}${normalizedPath}`;

  const {
    data: { session },
  } = await supabase.auth.getSession();

  console.log("apiFetch url:", url);
  console.log("has session:", !!session);
  console.log("has access token:", !!session?.access_token);

  const response = await fetch(url, {
    ...options,
    credentials: options.credentials ?? "include",
    headers: {
      "Content-Type": "application/json",
      ...(session?.access_token
        ? { Authorization: `Bearer ${session.access_token}` }
        : {}),
      ...(options.headers ?? {}),
    },
  });

  const payload = (await parseJsonSafely(response)) as
    | T
    | ApiErrorResponse
    | null;

  if (!response.ok) {
    const message =
      typeof payload === "object" &&
      payload !== null &&
      "error" in payload &&
      payload.error &&
      typeof payload.error === "object" &&
      "message" in payload.error &&
      typeof payload.error.message === "string"
        ? payload.error.message
        : typeof payload === "object" &&
            payload !== null &&
            "message" in payload &&
            typeof payload.message === "string"
          ? payload.message
          : `Request failed with status ${response.status}`;

    throw new Error(message);
  }

  return payload as T;
}